const { webvisorPages, enableWebvisorAllPages } = require('../private/ym-config.cjs');

const { CUSTOM_YTM_ID } = process.env;

const YTM_ADDITIONAL_CODE = `
    var product = 'RKO';
    var alfametrika_cookie = readCookie('_sp_id.3c2b');
    var link_nib = readCookie('link-abkeyres');

    ym(${CUSTOM_YTM_ID}, 'params', {
        product: product,
        alfametrika_cookie: alfametrika_cookie,
        link_nib: link_nib,
    });

    (function() {
        function dataLayerPush (data) {
            if (data) {
                if (data.product_name) {
                    ym(${CUSTOM_YTM_ID}, 'params', {
                        product_name: data.product_name,
                    });
                }
            }
        }

        if (window.DATA_LAYER) { window.DATA_LAYER.subscribe(dataLayerPush) }
    })();
`;

/**
 * Счетчики Яндекс.Метрики
 */
const ytm = url => `<script>
	(function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
   m[i].l=1*new Date();k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)})
   (window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");
    
     ym(${CUSTOM_YTM_ID}, "init", {
        clickmap:true,
        trackLinks:true,
        accurateTrackBounce:true,
        webvisor:${enableWebvisorAllPages ? true : webvisorPages.includes(url)},
        trackHash:false,
        ecommerce:"dataLayer",
   });
</script>`;

const ytmNoScript = `<noscript><div><img src="https://mc.yandex.ru/watch/${CUSTOM_YTM_ID}" style="position:absolute; left:-9999px;" alt="" /></div></noscript>`;

const ytmCookie = `<script type="text/javascript">
    function setCookie(name, value, days){
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000)); 
        var expires = "; expires=" + date.toGMTString();
        document.cookie = name + "=" + value + expires + ";path=/";
    }
    function getParam(p){
        var match = RegExp('[?&]' + p + '=([^&]*)').exec(window.location.search);
        return match && decodeURIComponent(match[1].replace(/\\+/g, ' '));
    }
    var yclid = getParam('yclid');
    if(yclid){
        setCookie('yclid', yclid, 90);
    }
</script>`;

const ytmSendUserParams = `
    <script>
     (function () {
        function readCookie(name) { 
          var n = name + "="; 
          var cookie = document.cookie.split(';'); 
          for(var i=0;i < cookie.length;i++) {      
              var c = cookie[i];      
              while (c.charAt(0)==' '){c = c.substring(1,c.length);}      
              if (c.indexOf(n) == 0){return c.substring(n.length,c.length);} 
          } 
          return null; 
          }

        function send (platformId) {
          var yid = readCookie('_ym_uid');
          var time = new Date().getTime();
          var ycl_id = readCookie('yclid');

          //параметры визита и параметры пользователя
          ym(${CUSTOM_YTM_ID}, 'params', {
            SessionID_YM: time + "." + yid,
            platformId: platformId,
            yclid: ycl_id,
            ClientID_YM: yid
          });

          ${YTM_ADDITIONAL_CODE}
        }
        // Логика ожидания
        var pid = readCookie('platformId');
        if (pid) {
          send(pid);
        } else {
          window.addEventListener(
            'platformIdReady',
            function handler (e) {
              window.removeEventListener('platformIdReady', handler);
              send(e.detail);
            },
            { once: true }
          );
        }
      })()
    </script>
`;

// TODO: event = site | gtm_push_params только ММБ
const ytmSendEvent = webAnalytics => `<script>
   var product = ${webAnalytics.product ? `'${webAnalytics.product}'` : 'undefined'};
   var productDetail = ${webAnalytics.productDetail ? `'${webAnalytics.productDetail}'` : 'undefined'};
   var pagetype = ${webAnalytics.pageType ? `'${webAnalytics.pageType}'` : 'undefined'};
   var path = ${webAnalytics.path ? `'${webAnalytics.path}'` : 'undefined'};
   ${
       webAnalytics.product && webAnalytics.pageType && webAnalytics.path
           ? `
     window.dataLayer.push({
        path,
        pagetype,
        product,
        ${webAnalytics.productDetail ? `'product_detail': productDetail,` : ''}
        event: 'gtm_push_params',
     });
   `
           : ''
   }
   function ytmSendEvent(dlvalues){
      product = dlvalues.product || product || '';
      productDetail = dlvalues.product_detail || productDetail || '';
      pagetype = dlvalues.pagetype || pagetype || '';
      path = path || dlvalues.path || '';
      var action = dlvalues.action || '';
      var block = dlvalues.block || '';
      var labelDetail = dlvalues.label_detail || '';
      var event = dlvalues.event || '';
      var dimension_40 = dlvalues.dimension_40 || '';
      var newProductDetail = productDetail && productDetail != 'undefined' ? '::'+ productDetail : ''
      var eventCategory = dlvalues.eventCategory || product+newProductDetail;
      var eventAction = dlvalues.eventAction || pagetype+'::'+block+'::'+action+'::'+dimension_40;
      var eventLabel = dlvalues.eventLabel || labelDetail+'::'+path;
      if (eventCategory && (event == 'gtm_interaction_event' || event == 'gtm_non_interaction_event')){
         ym(${CUSTOM_YTM_ID}, 'params', { 'event': { [eventCategory]: { [eventAction]: eventLabel }}});
      }
   }
   if (window.DATA_LAYER) { window.DATA_LAYER.subscribe(ytmSendEvent) }
</script>`;

module.exports = {
    ytm,
    ytmNoScript,
    ytmCookie,
    ytmSendUserParams,
    ytmSendEvent
};
